import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { environment } from '@environment';
import { ProfileModel } from '@models/profile.model';
import { map, tap } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { AddressModel } from '@models/user.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  public profileData?: ProfileModel;

  constructor(private http: HttpClient) { }

  getProfile(forceReload: boolean = false): Observable<ProfileModel> {
    if (!forceReload && this.profileData) {
      return of(this.profileData);
    }
    return this.http.get<ProfileModel>(environment.memberApiUrl + 'user/profile').pipe(tap(p => this.profileData = p));
  }

  changePassword(oldPassword: string, newPassword: string): Observable<any> {
    const body = {password: oldPassword, nPassword: newPassword};
    return this.http.put<any>(environment.memberApiUrl + 'user/profile/password', body);
  }

  changeEmail(newEmail: string): Observable<any> {
    return this.http.put<any>(environment.memberApiUrl + 'user/profile/mail', {email: newEmail});
  }

  updateAddress(profile: ProfileModel): Observable<any> {
    return this.http.put<any>(environment.memberApiUrl + 'user/profile/address', profile.address);
  }

  updateCompany(profile: AddressModel): Observable<any> {
    const clonedProfile = Object.assign({}, profile);
    // Disable reverse charge if no business user
    if (!clonedProfile.businessUser) {
      clonedProfile.useReverseCharge = false;
    }
    return this.http.put<any>(environment.memberApiUrl + 'user/profile/business', profile);
  }

  updateOther(profile: ProfileModel): Observable<any> {
    // Update nickname, language, newsletter, settings
    const updateProfile = this.http.put<any>(environment.memberApiUrl + 'user/profile', {
      language: profile.language,
      newsletter: !!profile.newsletter
    });
    const updateNickname = this.http.put<any>(environment.memberApiUrl + 'user/profile/nickname', { nickname: profile.nickname });
    const updateSettings = this.http.put<any>(environment.memberApiUrl + 'user/profile/settings', profile.settings);
    return forkJoin([updateProfile, updateNickname, updateSettings]);
  }

  deleteAccount(): Observable<any> {
    return this.http.delete<any>(environment.memberApiUrl + 'user');
  }

  getGdprStatus(): Observable<any> {
    return this.http.get<any>(environment.memberApiUrl + 'user/av-contract/status');
  }

  downloadGdprContract(): Observable<any> {
    return this.http.get(environment.memberApiUrl + 'user/av-contract', {responseType: 'blob'})
      .pipe(map(response => { FileSaver.saveAs(response, 'gdpr-contract.pdf'); return true; }));
  }

  signGdprContract(): Observable<any> {
    return this.http.post<any>(environment.memberApiUrl + 'user/av-contract', {});
  }

  revokeGdprContract(): Observable<any> {
    return this.http.delete<any>(environment.memberApiUrl + 'user/av-contract');
  }

}
